// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
import "../stylesheets/application";

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")

// Chart.js is loaded via CDN (see application layout).
function initDashboardCharts() {
  var ChartLib = window.Chart;
  var dataEl = document.getElementById("dash-chart-data");
  if (!ChartLib || !dataEl) return;

  var data;
  try {
    data = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var orange = "#f97316";
  var grid = "#2a3444";
  var muted = "#8b97a8";

  var sharedOptions = {
    responsive: true,
    maintainAspectRatio: false,
    legend: { display: false },
    tooltips: {
      mode: "index",
      intersect: false,
      backgroundColor: "#151b24",
      titleFontColor: "#f2f4f7",
      bodyFontColor: "#8b97a8",
      borderColor: "#2a3444",
      borderWidth: 1
    },
    scales: {
      xAxes: [{
        gridLines: { color: "transparent", zeroLineColor: "transparent" },
        ticks: { fontColor: muted, maxTicksLimit: 6, maxRotation: 0 }
      }],
      yAxes: [{
        gridLines: { color: grid, zeroLineColor: grid, drawBorder: false },
        ticks: { fontColor: muted, padding: 8, beginAtZero: false }
      }]
    }
  };

  var growthCanvas = document.getElementById("userGrowthChart");
  if (growthCanvas && data.userGrowth) {
    if (growthCanvas._hwChart) {
      growthCanvas._hwChart.destroy();
    }
    var growthCtx = growthCanvas.getContext("2d");
    var gradient = growthCtx.createLinearGradient(0, 0, 0, 160);
    gradient.addColorStop(0, "rgba(249, 115, 22, 0.35)");
    gradient.addColorStop(1, "rgba(249, 115, 22, 0)");

    growthCanvas._hwChart = new ChartLib(growthCtx, {
      type: "line",
      data: {
        labels: data.userGrowth.labels,
        datasets: [{
          label: "Cumulative users",
          data: data.userGrowth.values,
          borderColor: orange,
          backgroundColor: gradient,
          borderWidth: 2,
          pointRadius: 0,
          pointHoverRadius: 4,
          pointBackgroundColor: orange,
          lineTension: 0.3
        }]
      },
      options: sharedOptions
    });
  }

  var revenueCanvas = document.getElementById("revenueChart");
  if (revenueCanvas && data.revenue) {
    if (revenueCanvas._hwChart) {
      revenueCanvas._hwChart.destroy();
    }
    revenueCanvas._hwChart = new ChartLib(revenueCanvas.getContext("2d"), {
      type: "bar",
      data: {
        labels: data.revenue.labels,
        datasets: [{
          label: "Weekly charge volume ($)",
          data: data.revenue.values,
          backgroundColor: orange,
          hoverBackgroundColor: "#fb923c",
          borderWidth: 0,
          maxBarThickness: 28
        }]
      },
      options: Object.assign({}, sharedOptions, {
        scales: {
          xAxes: [{
            gridLines: { display: false },
            ticks: { fontColor: muted, maxRotation: 0 }
          }],
          yAxes: [{
            gridLines: { color: grid, zeroLineColor: grid, drawBorder: false },
            ticks: {
              fontColor: muted,
              padding: 8,
              beginAtZero: true,
              callback: function(value) { return "$" + value; }
            }
          }]
        }
      })
    });
  }
}

document.addEventListener("turbolinks:load", initDashboardCharts);
document.addEventListener("turbolinks:load", initNotificationCompose);
document.addEventListener("turbolinks:load", initUsersTable);

function initUsersTable() {
  document.querySelectorAll("tr.hw-user-row[data-href]").forEach(function(row) {
    row.addEventListener("click", function(event) {
      if (event.target.closest("a, button, input, label")) return;
      var href = row.getAttribute("data-href");
      if (href) window.location.href = href;
    });
  });
}

function initNotificationCompose() {
  var form = document.getElementById("compose-notification-form");
  if (!form) return;

  var allRadio = document.getElementById("audience-all");
  var selectedRadio = document.getElementById("audience-selected");
  var warn = document.getElementById("broadcast-warn");
  var picker = document.getElementById("user-picker");
  var searchInput = document.getElementById("user-picker-search");
  var listEl = document.getElementById("user-picker-list");
  var chipsEl = document.getElementById("user-picker-chips");
  var countEl = document.getElementById("user-picker-count");
  var idsEl = document.getElementById("user-picker-ids");
  var cards = form.querySelectorAll(".hw-audience-card");
  var selected = {};
  var searchTimer = null;
  var searchUrl = listEl ? listEl.getAttribute("data-search-url") : null;

  function syncAudience() {
    var isSelected = selectedRadio && selectedRadio.checked;
    cards.forEach(function(card) {
      var input = card.querySelector('input[type="radio"]');
      card.classList.toggle("is-active", !!(input && input.checked));
    });
    if (picker) picker.style.display = isSelected ? "block" : "none";
    if (warn) warn.hidden = !!isSelected;
  }

  function selectedCount() {
    return Object.keys(selected).length;
  }

  function renderChipsAndIds() {
    if (!chipsEl || !idsEl || !countEl) return;
    var ids = Object.keys(selected);
    chipsEl.innerHTML = ids.map(function(id) {
      var user = selected[id];
      return '<span class="hw-user-chip">' +
        escapeHtml(user.name) +
        '<button type="button" data-remove-id="' + id + '" aria-label="Remove">&times;</button>' +
        '</span>';
    }).join("");
    idsEl.innerHTML = ids.map(function(id) {
      return '<input type="hidden" name="user_ids[]" value="' + id + '">';
    }).join("");
    countEl.textContent = selectedCount() + " selected";
    chipsEl.querySelectorAll("[data-remove-id]").forEach(function(btn) {
      btn.addEventListener("click", function() {
        delete selected[btn.getAttribute("data-remove-id")];
        renderChipsAndIds();
        renderList(window.__hwPickerResults || []);
      });
    });
  }

  function escapeHtml(text) {
    return String(text || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function renderList(users) {
    window.__hwPickerResults = users;
    if (!listEl) return;
    if (!users.length) {
      listEl.innerHTML = '<div class="hw-user-empty">No users found.</div>';
      return;
    }
    listEl.innerHTML = users.map(function(user) {
      var checked = selected[user.id] ? " checked" : "";
      return '<label class="hw-user-row">' +
        '<input type="checkbox" data-user-id="' + user.id + '"' + checked + '>' +
        '<div class="hw-user-av">' + escapeHtml(user.initials || "?") + '</div>' +
        '<div class="hw-user-meta">' +
          '<div class="name">' + escapeHtml(user.name) + '</div>' +
          '<div class="email">' + escapeHtml(user.email) + '</div>' +
        '</div>' +
      '</label>';
    }).join("");

    listEl.querySelectorAll('input[type="checkbox"]').forEach(function(cb) {
      cb.addEventListener("change", function() {
        var id = cb.getAttribute("data-user-id");
        var user = (window.__hwPickerResults || []).find(function(u) { return String(u.id) === String(id); });
        if (cb.checked && user) {
          selected[id] = user;
        } else {
          delete selected[id];
        }
        renderChipsAndIds();
      });
    });
  }

  function runSearch(query) {
    if (!searchUrl) return;
    var url = searchUrl + (searchUrl.indexOf("?") >= 0 ? "&" : "?") + "q=" + encodeURIComponent(query || "");
    fetch(url, { headers: { "Accept": "application/json" }, credentials: "same-origin" })
      .then(function(res) { return res.json(); })
      .then(function(users) { renderList(users); })
      .catch(function() {
        listEl.innerHTML = '<div class="hw-user-empty">Could not load users.</div>';
      });
  }

  if (allRadio) allRadio.addEventListener("change", syncAudience);
  if (selectedRadio) selectedRadio.addEventListener("change", syncAudience);
  syncAudience();
  renderChipsAndIds();
  runSearch("");

  if (searchInput) {
    searchInput.addEventListener("input", function() {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(function() {
        runSearch(searchInput.value);
      }, 200);
    });
  }

  form.addEventListener("submit", function(event) {
    if (allRadio && allRadio.checked) {
      var ok = window.confirm("Send this notification to all users?");
      if (!ok) {
        event.preventDefault();
        return;
      }
    }
    if (selectedRadio && selectedRadio.checked && selectedCount() === 0) {
      event.preventDefault();
      window.alert("Select at least one user.");
    }
  });
}

$(document).on("click", ".open-deleteadminModal", function() {
  var admin_id = $(this).data("admin_id");
  $(".modal-body #id").val(admin_id);
});
$(document).on("click", ".open-editadminModal", function() {
  var admin_id = $(this).data("admin_id");
  $(".modal-body #id").val(admin_id);
  $.ajax({
    url: "/admins/" + admin_id + "",
    type: "GET",
    success: (data) => {
      $(".modal-body #admin_email").val(data["email"]);
      $(".modal-body #admin_first_name").val(data["first_name"]);
      $(".modal-body #admin_last_name").val(data["last_name"]);
      $(".modal-body #admin_role").val(data["role"]);
    },
  });
});
